<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
  import themeConfig from "@/../themeConfig.js";
  import jwt from "@/http/requests/auth/jwt/index.js";
  import firebase from "firebase/compat/app";
  import "firebase/compat/messaging";
  // import 'firebase/database'
  export default {
    data() {
      return {
        vueAppClasses: [],
        listenersStarted: false,
        idToken: "",
        messaging: null,
      };
    },
    watch: {
      "$store.state.theme"(val) {
        this.toggleClassInBody(val);
      },
      "$vs.rtl"(val) {
        document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
      },
    },
    mounted() {
      this.toggleClassInBody(themeConfig.theme);
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      const vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty("--vh", `${vh}px`);
      
      try {
        this.messaging = firebase.messaging();
        this.startListeners();
      } catch (e) {
        //
      }
    },
    async created() {
      // jwt
      jwt.init();

      const dir = this.$vs.rtl ? "rtl" : "ltr";
      document.documentElement.setAttribute("dir", dir);

      window.addEventListener("resize", this.handleWindowResize);
      window.addEventListener("scroll", this.handleScroll);

      // Auth0
      try {
        // await this.$auth.renewTokens(); // Disabled to prevent 403 error on dev
      } catch (e) {
        console.error(e);
      }
    },
    destroyed() {
      window.removeEventListener("resize", this.handleWindowResize);
      window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
      toggleClassInBody(className) {
        if (className === "dark") {
          if (document.body.className.match("theme-semi-dark"))
            document.body.classList.remove("theme-semi-dark");
          document.body.classList.add("theme-dark");
        } else if (className === "semi-dark") {
          if (document.body.className.match("theme-dark"))
            document.body.classList.remove("theme-dark");
          document.body.classList.add("theme-semi-dark");
        } else {
          if (document.body.className.match("theme-dark"))
            document.body.classList.remove("theme-dark");
          if (document.body.className.match("theme-semi-dark"))
            document.body.classList.remove("theme-semi-dark");
        }
      },
      setAppClasses(classesStr) {
        this.vueAppClasses.push(classesStr);
      },
      handleWindowResize() {
        this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

        // Set --vh property
        document.documentElement.style.setProperty(
          "--vh",
          `${window.innerHeight * 0.01}px`,
        );
      },
      handleScroll() {
        this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
      },
      // FCM NOTIFICATION FUNCTIONS
      async startListeners() {
        await this.startOnMessageListener();
        // await this.startTokenRefreshListener()
        await this.requestPermission();
        await this.getIdToken();
        this.listenersStarted = true;
      },
      startOnMessageListener() {
        try {
          this.messaging.onMessage((payload) => {
            console.info("Message received : ", payload);
            console.log(payload.notification.body);
          });
        } catch (e) {
          console.error("Error : ", e);
        }
      },
      async requestPermission() {
        try {
          const permission = await Notification.requestPermission();
          console.log("GIVEN notify perms");
          console.log(permission);
        } catch (e) {
          console.error("Error : ", e);
        }
      },
      async getIdToken() {
        try {
          this.idToken = await this.messaging.getToken({
            vapidKey:
              "BJ-z_hN0VKaT8ZS-8wkgT5MTSt0ArZjBy4YqIWGpnoPi9DrBF0WxR7oXXXYXqYM9hdU5VBuPmwU3DqrTCtk2P3E",
          });
          console.log("TOKEN ID FOR this browser");
          console.log(this.idToken);
        } catch (e) {
          console.error("Error : ", e);
        }
      },
    },
  };
</script>

<style>
  .select-cus {
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 9.8px;
    width: 100%;
    border-radius: 5px;
    max-height: 38.5px;
  }
</style>
